import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_STATUSSAMPLE,
  DELETE_STATUSSAMPLE,
  GET_STATUSSAMPLES,
  UPDATE_STATUSSAMPLE,
  UPDATE_STATUSSAMPLE_STATUS
} from "./actionTypes";

import {
  addStatusSampleFail,
  addStatusSampleSuccess,
  deleteStatusSampleFail,
  deleteStatusSampleSuccess,
  getStatusSamplesFail,
  getStatusSamplesSuccess,
  setState,
  updateStatusSampleFail,
  updateStatusSampleSuccess,
} from "./actions";

import { statusSamples, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchStatusSamples({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, statusSamples, params.toString());
    yield put(setState(false));
    yield put(getStatusSamplesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getStatusSamplesFail(error));
  }
}

function* updateStatusSample({ payload: statusSampleObj }) {
  try {
    const { id, recordStatus, ...rest } = statusSampleObj;
    yield call(patchApiCall, `${statusSamples}/${id}`, rest);
    const response = yield call(getTable, `${statusSamples}/${statusSampleObj.id}`);
    yield put(updateStatusSampleSuccess(response));
  } catch (error) {
    yield put(updateStatusSampleFail(error));
  }
}

function* updateStatusSampleStatus({ payload: statusSampleObj }) {
  try {
    const { id } = statusSampleObj;
    yield call(patchApiCall, `${statusSamples}/${updateStatus}/${id}`, { recordStatus: statusSampleObj.recordStatus });
    const response = yield call(getTable, `${statusSamples}/${statusSampleObj.id}`);
    yield put(updateStatusSampleSuccess(response));
  } catch (error) {
    yield put(updateStatusSampleFail(error));
  }
}

function* deleteStatusSample({ payload: statusSampleObj }) {
  try {
    yield call(deleteApiCall, `${statusSamples}/${statusSampleObj.id}`);
    yield put(deleteStatusSampleSuccess(statusSampleObj.id));
  } catch (error) {
    yield put(deleteStatusSampleFail(error));
  }
}

function* postingStatusSample({ payload: statusSample }) {
  try {
    const response = yield call(postApiCall, statusSamples, statusSample);
    yield put(addStatusSampleSuccess(response));
  } catch (error) {
    yield put(addStatusSampleFail(error));
  }
}

function* statusSamplesSaga() {
  yield takeEvery(GET_STATUSSAMPLES, fetchStatusSamples);
  yield takeEvery(ADD_NEW_STATUSSAMPLE, postingStatusSample);
  yield takeEvery(UPDATE_STATUSSAMPLE, updateStatusSample);
  yield takeEvery(UPDATE_STATUSSAMPLE_STATUS, updateStatusSampleStatus);
  yield takeEvery(DELETE_STATUSSAMPLE, deleteStatusSample);
}

export default statusSamplesSaga;
